// actions/packageActions.js
import {
    FETCH_PACKAGES_REQUEST,
    FETCH_PACKAGES_SUCCESS,
    FETCH_PACKAGES_FAILURE,
    ADD_SIZE_ESTIMATE_REQUEST,
    ADD_SIZE_ESTIMATE_SUCCESS,
    ADD_SIZE_ESTIMATE_FAILURE,
    FETCH_SIZE_ESTIMATES_REQUEST,
    FETCH_SIZE_ESTIMATES_SUCCESS,
    FETCH_SIZE_ESTIMATES_FAILURE,
    FETCH_ALL_SIZE_ESTIMATES_REQUEST,
    FETCH_ALL_SIZE_ESTIMATES_SUCCESS,
    FETCH_ALL_SIZE_ESTIMATES_FAILURE,
    UPDATE_SIZE_ESTIMATE_REQUEST,
    UPDATE_SIZE_ESTIMATE_SUCCESS,
    UPDATE_SIZE_ESTIMATE_FAILURE,
  } from './types';
  import { fetchPackages, addSizeEstimate, fetchSizeEstimate, fetchAllSizeEstimates, updateSizeEstimate  } from "../../services/packageService"; 

  
  // Action Creators
  export const fetchPackagesRequest = () => ({ type: FETCH_PACKAGES_REQUEST });
  export const fetchPackagesSuccess = (packagesData) => ({
    type: FETCH_PACKAGES_SUCCESS,
    payload: packagesData,
  });
  export const fetchPackagesFailure = (error) => ({
    type: FETCH_PACKAGES_FAILURE,
    payload: error,
  });

  // Size estimate Action Creators
export const addSizeEstimateRequest = () => ({ type: ADD_SIZE_ESTIMATE_REQUEST });
export const addSizeEstimateSuccess = (sizeEstimateData) => ({
  type: ADD_SIZE_ESTIMATE_SUCCESS,
  payload: sizeEstimateData,
});
export const addSizeEstimateFailure = (error) => ({
  type: ADD_SIZE_ESTIMATE_FAILURE,
  payload: error,
});

// Action Creators for Size Estimates
export const fetchSizeEstimatesRequest = () => ({ type: FETCH_SIZE_ESTIMATES_REQUEST });
export const fetchSizeEstimatesSuccess = (sizeEstimatesData) => ({
  type: FETCH_SIZE_ESTIMATES_SUCCESS,
  payload: sizeEstimatesData,
});
export const fetchSizeEstimatesFailure = (error) => ({
  type: FETCH_SIZE_ESTIMATES_FAILURE,
  payload: error,
});
  
//Action to fetch all Sizes
export const fetchAllSizeEstimatesRequest = () => ({
  type: FETCH_ALL_SIZE_ESTIMATES_REQUEST,
});
export const fetchAllSizeEstimatesSuccess = (data) => ({
  type: FETCH_ALL_SIZE_ESTIMATES_SUCCESS,
  payload: data,
});
export const fetchAllSizeEstimatesFailure = (error) => ({
  type: FETCH_ALL_SIZE_ESTIMATES_FAILURE,
  payload: error,
});

//Update Size estimates
export const updateSizeEstimateRequest = () => ({ type: UPDATE_SIZE_ESTIMATE_REQUEST });
export const updateSizeEstimateSuccess = (updatedEstimate) => ({
  type: UPDATE_SIZE_ESTIMATE_SUCCESS,
  payload: updatedEstimate,
});
export const updateSizeEstimateFailure = (error) => ({
  type: UPDATE_SIZE_ESTIMATE_FAILURE,
  payload: error,
});




  // Thunk to fetch packages
  export const fetchPackagesAction = (filterField, filterValue, page = 1, size = 10) => async (dispatch) => {
    dispatch(fetchPackagesRequest());
  
    try {
      const response = await fetchPackages(filterField, filterValue, page, size);
  
      if (response.error) {
        dispatch(fetchPackagesFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(fetchPackagesSuccess(response));

        return { success: true, data: response };
      }
    } catch (error) {
      dispatch(fetchPackagesFailure(error.message || "Failed to fetch packages"));
      return { success: false, error: error.message || "Failed to fetch packages" };
    }
  };
  

// Thunk to add size estimate
export const addSizeEstimateAction = (sizeEstimate) => async (dispatch) => {
  dispatch(addSizeEstimateRequest());

  try {
    const response = await addSizeEstimate(sizeEstimate);

    if (response.error) {
      dispatch(addSizeEstimateFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(addSizeEstimateSuccess(response));

      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(addSizeEstimateFailure(error.message || "Failed to add size estimate"));
    return { success: false, error: error.message || "Failed to add size estimate" };
  }
};

// Thunk to fetch size estimates
export const fetchSizeEstimatesAction = (size) => async (dispatch) => {
  dispatch(fetchSizeEstimatesRequest());

  try {
    const response = await fetchSizeEstimate(size);

    if (response.error) {
      dispatch(fetchSizeEstimatesFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchSizeEstimatesSuccess(response));

      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchSizeEstimatesFailure(error.message || "Failed to fetch size estimates"));
    return { success: false, error: error.message || "Failed to fetch size estimates" };
  }
};

// Thunk to fetch all size estimates (not by category)
export const fetchAllSizeEstimatesAction = () => async (dispatch) => {
  dispatch(fetchAllSizeEstimatesRequest());

  try {
    const response = await fetchAllSizeEstimates();

    if (response.error) {
      dispatch(fetchAllSizeEstimatesFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchAllSizeEstimatesSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchAllSizeEstimatesFailure(error.message || "Failed to fetch all size estimates"));
    return { success: false, error: error.message || "Failed to fetch all size estimates" };
  }
};

//Thunk to Update Size Estimate
export const updateSizeEstimateAction = (sizeCategory, payload) => async (dispatch) => {
  dispatch(updateSizeEstimateRequest());

  try {
    const response = await updateSizeEstimate(sizeCategory, payload);

    if (response.error) {
      dispatch(updateSizeEstimateFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(updateSizeEstimateSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(updateSizeEstimateFailure(error.message || "Failed to update size estimate"));
    return { success: false, error: error.message || "Failed to update size estimate" };
  }
};
